var _defs, _rect, _circle, _circle2, _circle3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicesHeroVisual(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 94,
    y1: 82,
    x2: 1050,
    y2: 808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "panel",
    x1: 158,
    y1: 124,
    x2: 1002,
    y2: 722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13263A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244C73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glass",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEFFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "warm",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cool",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F7EEA"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: 74,
    y: 92,
    width: 1052,
    height: 714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 30,
    stdDeviation: 28,
    floodColor: "#5C87B2",
    floodOpacity: 0.22
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    rx: 48,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 172,
    r: 112,
    fill: "#FFE2B8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1030,
    cy: 730,
    r: 138,
    fill: "#D7EBFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1042,
    cy: 168,
    r: 72,
    fill: "#EAF5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 124,
    width: 948,
    height: 558,
    rx: 38,
    fill: "url(#panel)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 124,
    width: 948,
    height: 558,
    rx: 38,
    stroke: "#C8E0F7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 176,
    width: 356,
    height: 246,
    rx: 30,
    fill: "url(#glass)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 214,
    y: 234,
    fill: "#F9854F",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24,
    letterSpacing: 4
  }, "SERVICE FLOW"), /*#__PURE__*/React.createElement("text", {
    x: 214,
    y: 308,
    fill: "#17314A",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 56,
    fontWeight: 700
  }, "Design to"), /*#__PURE__*/React.createElement("text", {
    x: 214,
    y: 372,
    fill: "#17314A",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 56,
    fontWeight: 700
  }, "Growth"), /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 394,
    width: 182,
    height: 14,
    rx: 7,
    fill: "#FFD4A3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 394,
    width: 118,
    height: 14,
    rx: 7,
    fill: "url(#warm)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 176,
    width: 440,
    height: 150,
    rx: 28,
    fill: "#102337",
    fillOpacity: 0.72,
    stroke: "#7FB8E8",
    strokeOpacity: 0.4,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 622,
    y: 226,
    fill: "#BFE4FF",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 22,
    letterSpacing: 3
  }, "CHANNELS CONNECTED"), /*#__PURE__*/React.createElement("path", {
    d: "M628 274H744",
    stroke: "#6DC7FF",
    strokeWidth: 18,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780 274H930",
    stroke: "#FF9B6F",
    strokeWidth: 18,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628 304H876",
    stroke: "#D7EDFF",
    strokeWidth: 12,
    strokeLinecap: "round",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 470,
    width: 220,
    height: 146,
    rx: 26,
    fill: "url(#glass)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 430,
    width: 284,
    height: 186,
    rx: 28,
    fill: "#F7FBFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 724,
    y: 454,
    width: 302,
    height: 162,
    rx: 28,
    fill: "url(#glass)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 524,
    r: 26,
    fill: "#FFF1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 524H247",
    stroke: "#FF8B58",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 513V535",
    stroke: "#FF8B58",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 218,
    y: 572,
    fill: "#5E7691",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 18,
    letterSpacing: 3
  }, "BUILD"), /*#__PURE__*/React.createElement("text", {
    x: 218,
    y: 607,
    fill: "#16324B",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 700
  }, "Web + App"), /*#__PURE__*/React.createElement("circle", {
    cx: 478,
    cy: 486,
    r: 22,
    fill: "#E6F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 486H489",
    stroke: "#2F7EEA",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 475V497",
    stroke: "#2F7EEA",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 490,
    fill: "#5E7691",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 18,
    letterSpacing: 3
  }, "AUTOMATE"), /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 528,
    fill: "#16324B",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 36,
    fontWeight: 700
  }, "AI Agents"), /*#__PURE__*/React.createElement("rect", {
    x: 458,
    y: 554,
    width: 204,
    height: 14,
    rx: 7,
    fill: "#D7EAFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458,
    y: 554,
    width: 136,
    height: 14,
    rx: 7,
    fill: "url(#cool)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784,
    cy: 512,
    r: 24,
    fill: "#FFF1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774 522L784 502L794 522",
    stroke: "#FF8B58",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 518,
    fill: "#5E7691",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 18,
    letterSpacing: 3
  }, "GROW"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 556,
    fill: "#16324B",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 36,
    fontWeight: 700
  }, "SEO + Ads"), /*#__PURE__*/React.createElement("path", {
    d: "M820 584H944",
    stroke: "#C8DDF0",
    strokeWidth: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 584H902",
    stroke: "url(#warm)",
    strokeWidth: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 544C420 532 438 520 454 504",
    stroke: "#8CBCE3",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeDasharray: "10 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 520C720 522 740 522 760 518",
    stroke: "#8CBCE3",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeDasharray: "10 12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 656,
    width: 290,
    height: 18,
    rx: 9,
    fill: "#D9EAF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 656,
    width: 146,
    height: 18,
    rx: 9,
    fill: "url(#cool)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesHeroVisual);
export default __webpack_public_path__ + "static/media/services-hero-visual.6c4b5fe0d038e03c5eba413269377173.svg";
export { ForwardRef as ReactComponent };